import { ReactNode } from "react";
import React, { cloneElement, ReactElement } from "react";
import { motion, HTMLMotionProps } from "framer-motion";

// Wir definieren ein Interface, das alle normalen Section-Eigenschaften
// + die Framer-Motion-Eigenschaften erlaubt
interface RevealSectionProps extends HTMLMotionProps<"section"> {
    children: React.ReactNode;
}

export const RevealSection = ({ children,className, ...props }: RevealSectionProps) => (
    <motion.section
        className = {className}// Hier werden className, style, etc. weitergereicht
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.5 }}
        {...props}
    >
        {children}
    </motion.section>
);